import React, { useEffect,useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { MESSAGES } from '../../../constants/constants.js';

import { initialFormData, initialErrors, fieldValidation  } from '../../../common/helper/form-constants.js';
const EditCallBack = (props) => {
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

  const [formData, setFormData] = useState({webhook_url:'', webhook_secret: '',webhook_alert_email:'',webhook_url_payout:'',webhook_secret_payout:'', webhook_alert_email_payout:''});
  const [errors, setErrors] = useState({ ...initialErrors });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  };

  const validateField = (fieldName, value) => {
    const errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    return errorMessage
  };
  const handleCheckboxChange = () => {
    setIsCheckboxChecked((prev) => !prev);
  }
  useEffect(() => {
    console.log(isCheckboxChecked)
    if (isCheckboxChecked) {
      setFormData((prevData) => ({
        ...prevData,
        webhook_url_payout:prevData.webhook_url,
        webhook_secret_payout: prevData.webhook_secret,
        webhook_alert_email_payout: prevData.webhook_alert_email,
      }));
    }
  }, [isCheckboxChecked, formData.webhook_url, formData.webhook_secret,formData.webhook_alert_email]);
  const onSave = (e) => {
    e.preventDefault();
    let hasErrors;
    Object.keys(formData).forEach(fieldName => {
      const error = validateField(fieldName, formData[fieldName]);
      if (error) {
          hasErrors = true;
      }
  });
  if(!hasErrors) {
    props.onSubmit(formData);
  }
    
  }
  useEffect(() => {
    console.log(props.data) // coming
    if(props && props.data) {
      setFormData({
        webhook_url: props.data.call_back_payin_url_success,
        webhook_secret: props.data.call_back_payin_url_fail,
        webhook_alert_email: props.data.call_back_payin_url_pending,
        webhook_url_payout: props.data.call_back_payout_url_success,
        webhook_secret_payout: props.data.call_back_payout_url_fail,
        webhook_alert_email_payout: props.data.call_back_payout_url_pending,
      })
    }
    console.log(formData)

  }, []);

    return (
      <>
       <Modal  {...props}>
        <Modal.Header closeButton>
          <Modal.Title> Edit CallBacks</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form action="#" method="post">
            <div class="row">
            {/* <input
                type="checkbox"
                style={{ marginTop: '15px' , marginLeft: '12px' }}
                checked={isCheckboxChecked}
                onChange={handleCheckboxChange}
              /> */}
              {/* <label htmlFor="keyid">Success URL</label> */}
            </div>
            <div class="row">
              <div class="col-sm-12">
                <h4 style={{textAlign:'center'}}>Pay In </h4>
              <div className="form-group" style={{ textAlign: 'left', marginBottom: '5px' }}>
              <label htmlFor="keyid">Success URL</label>
              <input
                type="text"
                className={`form-control ${errors.webhook_url ? 'is-invalid' : ''}`}
                id="email"
                placeholder="Enter Success URL"
                value={formData.webhook_url}
                name="webhook_url"
                onChange={handleChange}
              />
              {errors.webhook_url && <div className="invalid-feedback">{errors.webhook_url}</div>}
            </div>
            <div className="form-group" style={{ textAlign: 'left', marginBottom: '5px' }}>
              <label htmlFor="keysecret">Failure URL</label>
              <input
                type="text"
                className={`form-control ${errors.webhook_secret ? 'is-invalid' : ''}`}
                id="secret"
                placeholder="Failure URL"
                name="webhook_secret"
                value={formData.webhook_secret}
                onChange={handleChange}
              
              />
              {errors.webhook_secret && <div className="invalid-feedback">{errors.webhook_secret}</div>}
            </div>
            <div className="form-group" style={{ textAlign: 'left', marginBottom: '5px' }}>
              <label htmlFor="keysecret">Pending URL</label>
              <input
                type="email"
                className={`form-control ${errors.webhook_alert_email ? 'is-invalid' : ''}`}
                id="email"
                placeholder="Enter Pending URL"
                value={formData.webhook_alert_email}
                name="webhook_alert_email"
                onChange={handleChange}
              
              />
              {errors.webhook_alert_email && <div className="invalid-feedback">{errors.webhook_alert_email}</div>}
            </div>
              </div>
           
              <div class="col-sm-12">
                 <input 
                type="checkbox"
                style={{textAlign:'center' }}
                checked={isCheckboxChecked}
                onChange={handleCheckboxChange}
              /> <h4  style={{textAlign:'center', display:'inline-flex'}}>Same as Pay In</h4>
              <h4 style={{textAlign:'center'}}>Pay Out</h4>
              <div className="form-group" style={{ textAlign: 'left', marginBottom: '5px' }}>
              <label htmlFor="keyid">Success URL</label>
              
              <input
                type="text"
                className={`form-control ${errors.webhook_url_payout ? 'is-invalid' : ''}`}
                id="email"
                placeholder="Enter Success URL"
                value={formData.webhook_url_payout}
                name="webhook_url_payout"
                onChange={handleChange}
                disabled={isCheckboxChecked}
              />
              {errors.webhook_url_payout && <div className="invalid-feedback">{errors.webhook_url_payout}</div>}
            </div>
            <div className="form-group" style={{ textAlign: 'left', marginBottom: '5px' }}>
              <label htmlFor="keysecret">Failure URL</label>
              <input
                type="text"
                className={`form-control ${errors.webhook_secret_payout ? 'is-invalid' : ''}`}
                id="secret"
                placeholder="Failure URL"
                name="webhook_secret_payout"
                value={formData.webhook_secret_payout}
                onChange={handleChange}
                disabled={isCheckboxChecked}
              />
              {errors.webhook_secret_payout && <div className="invalid-feedback">{errors.webhook_secret_payout}</div>}
            </div>
            <div className="form-group" style={{ textAlign: 'left', marginBottom: '5px' }}>
              <label htmlFor="keysecret">Pending URL</label>
              <input
                type="email"
                className={`form-control ${errors.webhook_alert_email_payout ? 'is-invalid' : ''}`}
                id="email"
                placeholder="Enter Pending URL"
                value={formData.webhook_alert_email_payout}
                name="webhook_alert_email_payout"
                onChange={handleChange}
                disabled={isCheckboxChecked}
              />
              {errors.webhook_alert_email_payout && <div className="invalid-feedback">{errors.webhook_alert_email_payout}</div>}
            </div>
              </div>
              </div>
          </form>

        {/* <form action="#" method="post">
        <div className="form-group" style={{textAlign: 'left', marginBottom: '5px'}}>
          <label htmlFor="keyid">Webhook URL</label>
          <input type="text" className={`form-control ${errors.webhook_url ? 'is-invalid' : ''}`}   id="email" placeholder="Enter Webhook URL" value ={formData.webhook_url} name="webhook_url"  onChange={handleChange} />
          {errors.webhook_url && <div className="invalid-feedback">{errors.webhook_url}</div>}
        </div>
        <div className="form-group" style={{textAlign: 'left', marginBottom: '5px'}}>
          <label htmlFor="keysecret">Secret</label>
          <input type="text" className={`form-control ${errors.webhook_secret ? 'is-invalid' : ''}`}   id="secret" placeholder="Enter Secret" name="webhook_secret" value ={formData.webhook_secret} onChange={handleChange} />
          {errors.webhook_secret && <div className="invalid-feedback">{errors.webhook_secret}</div>}
        </div>
        <div className="form-group" style={{textAlign: 'left', marginBottom: '5px'}}>
          <label htmlFor="keysecret">Alert Email</label>
          <input type="email" className={`form-control ${errors.webhook_alert_email ? 'is-invalid' : ''}`}   id="email" placeholder="Enter Alert Email"   value ={formData.webhook_alert_email} name="webhook_alert_email"  onChange={handleChange} />
          {errors.webhook_alert_email && <div className="invalid-feedback">{errors.webhook_alert_email}</div>}
        </div>
      </form> */}
            
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onHide}>
            Close
          </Button>
          <Button variant="primary" onClick={onSave}>
            Sumbit
          </Button>
        </Modal.Footer>
      </Modal>
      </>
    );
  }
  


  export default EditCallBack;



